import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { liveRoute, casesRoute } from '../../../routes';

import Splitter from '../block/splitter';
import ContentBlock from '../block/content';
import ConfirmDialog from  '../../form/confirm';

import GenericStep from './stepGeneric';
import translate from '../../../utils/translate';
import { getLogin } from '../../../actions/users';


export default class AccountCaseCreateStep4 extends Component {
	static propTypes = {
		activeStep: PropTypes.number.isRequired,
		onSubmit: PropTypes.func.isRequired,
		slug: PropTypes.string.isRequired,
		dispatch: PropTypes.func.isRequired,
	};

	static defaultProps = {
		active: false,
		onSubmit: function(promise) { promise.then(() => {}).catch(() => {}); },
	};

	constructor(props) {
		super();

		this.state = {};
	}

	componentWillMount() {}

	componentWillReceiveProps(nextProps) {
		if (this.props.activeStep !== 4 && nextProps.activeStep === 4) {
			this.props.dispatch(getLogin());
		}
	}

	render() {
		let text = translate('account/casecreate/outro', true, false, '_self');
		text = text.replace('%case-link%', casesRoute(this.props.slug));

		return (
			<GenericStep
				active={(this.props.activeStep === 4)}
				stepNumber='04'
				stepTitle='Confirmation'
			>
				<ContentBlock title='Submission successful' smallAside={true}>
					<div className='span5 span100p-mobile' dangerouslySetInnerHTML={{ __html: text}} />
				</ContentBlock>

				<ContentBlock className='pixel-pattern pixel-pattern--01' smallAside={true}>
					<div className='span100p'>
						<div className='account-process__button-area'>
							<Link to={liveRoute()} type='submit' className='button button--dark'>Live Judging</Link>
							<span className='account-process__button-area__button-desc'>Go to the live judging page</span>
						</div>
					</div>
				</ContentBlock>
			</GenericStep>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/caseCreate/step4.js
 **/